import { render, staticRenderFns } from "./indoorareamodal.vue?vue&type=template&id=21abb6de&scoped=true"
import script from "./indoorareamodal.vue?vue&type=script&lang=js"
export * from "./indoorareamodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21abb6de",
  null
  
)

export default component.exports